import React from 'react'
import { useTheme } from '../../hooks/useTheme'

export type ActionButtonType = 'edit' | 'delete' | 'view' | 'add'

interface ActionButtonProps {
  type: ActionButtonType
  onClick: () => void
  disabled?: boolean
  title?: string
  className?: string
}

const ActionButton: React.FC<ActionButtonProps> = ({
  type,
  onClick,
  disabled = false,
  title,
  className = ''
}) => {
  const { colors } = useTheme()

  const iconMap: Record<ActionButtonType, string> = {
    edit: '✏️',
    delete: '🗑️',
    view: '👁️',
    add: '➕',
  }

  const colorMap: Record<ActionButtonType, string> = {
    edit: colors.primary,
    delete: colors.error,
    view: colors.primary,
    add: colors.primary,
  }

  const defaultTitle: Record<ActionButtonType, string> = {
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver',
    add: 'Agregar',
  }

  const icon = iconMap[type]
  const color = colorMap[type]
  const buttonTitle = title || defaultTitle[type]

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={buttonTitle}
      className={`inline-flex items-center justify-center w-10 h-10 rounded-lg transition-all duration-300 ease-out cursor-pointer ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'hover:scale-110'
      } ${className}`}
      style={{
        color: disabled ? '#ccc' : color,
        backgroundColor: 'transparent',
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = `${color}10`
        }
      }}
      onMouseLeave={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = 'transparent'
        }
      }}
    >
      <span className="text-lg">{icon}</span>
    </button>
  )
}

export default ActionButton
